<template>
  <templatePublicComponent>
    <div>                
      <h3>Événements :</h3>
      <div class="content">
          <div v-for="item in eventitems" :key="item.ID">
              <h6>{{item.Date | formatDateTime}}</h6>
              <p>{{item.Description}}</p>
          </div>
      </div>
    </div>
  </templatePublicComponent>
</template>

<script>
import TemplatePublicComponent from '../components/TemplatePublic.vue'
import APIEvent from '@/api/event'
const APIService = new APIEvent();

var axios = require('axios')

export default {
  components:
  {
    TemplatePublicComponent
  },
    data () {
        return {
            eventitems: [],
        }
    },
    created(){
        this.initialize()
    },
    methods: {
        initialize () {
            var events = APIService.getAll().then(response =>  {
                this.eventitems = response.data
            }
        )}
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Evenements.vue